import { OnlyForScreenReader } from '@brandfolder/react';
import React, {
  useState,
  FunctionComponent,
  SyntheticEvent,
} from 'react';

import { ActionsDropdown } from '@components/library/dropdown/index';
import { ActionDropdownItem } from '@components/library/dropdown_item/index';

import DeleteModal from './DeleteModal';
import SettingsModal from './SettingsModal';

interface CardActionsProps {
  brandguideKey: string;
  organizationKey: string | null;
  slug: string;
}

const CardActions: FunctionComponent<CardActionsProps> = ({
  brandguideKey,
  organizationKey,
  slug
}) => {
  const [closeDropdown, setCloseDropdown] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const editBrandguide = (_: string, e: SyntheticEvent): void => {
    e.preventDefault();
    window.open(`${BFG.brandguideUrl}?redirect=${slug}`, '_blank');
  };

  const openDeleteModal = (_: string, e: SyntheticEvent): void => {
    e.preventDefault();
    setShowDeleteModal(true);
  };

  const openSettingsModal = (_: string, e: SyntheticEvent): void => {
    e.preventDefault();
    setShowSettingsModal(true);
  };

  const brandguideV2 = BFG.hasFeature('rollout_brandguide_v2');

  return (
    <>
      <ActionsDropdown
        className="brandguide-card-actions"
        closeCallback={(): void => setCloseDropdown(false)}
        openOnClick={false}
        openOnHover
        toggleDropdown={closeDropdown}
        userDevice={BFG?.currentUser?.device}
      >
        {brandguideV2 && (
          <ActionDropdownItem
            key="edit-brandguide"
            icon="bff-edit"
            name="edit-brandguide"
            onChoose={editBrandguide}
          >
            {bfTranslate('Edit')}
            <OnlyForScreenReader>{bfTranslate('Opens in a new tab.')}</OnlyForScreenReader>
          </ActionDropdownItem>
        )}
        <ActionDropdownItem
          key="edit-brandguide-settings"
          icon="bff-settings"
          name="edit-brandguide-settings"
          onChoose={openSettingsModal}
        >
          {bfTranslate('Settings')}
        </ActionDropdownItem>
        {brandguideV2 && (
          <ActionDropdownItem
            key="delete-brandguide"
            icon="bff-trash"
            isWarningItem
            name="delete-brandguide"
            onChoose={openDeleteModal}
          >
            {bfTranslate('Delete Brandguide')}
          </ActionDropdownItem>
        )}
      </ActionsDropdown>
      {showSettingsModal && (
        <SettingsModal
          brandguideKey={brandguideKey}
          closeModal={(): void => setShowSettingsModal(false)}
          organizationKey={organizationKey}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          brandguideKey={brandguideKey}
          closeModal={(): void => setShowDeleteModal(false)}
        />
      )}
    </>
  );
};

export default CardActions;
